/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	MetaLocationSearchCitiesQueryParams,
	MetaLocationSearchCitiesResponse,
} from '../types/MetaLocationSearchCities'

/**
 * GET /meta/cities
 * @see backend/nexus/modules/MetaAd/Http/Controllers/MetaLocationController.php MetaLocationController::searchCities
 */
export async function metaLocationSearchCities(
	params?: MetaLocationSearchCitiesQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<MetaLocationSearchCitiesResponse>> {
	return axiosInstance.get('/meta/cities', { params, ...config })
}
